
define('modules/application/wizard/steps/zoneStep/thermoZoneStep/zonesMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",
  "../zonesMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  zonesMenuView) {

  var thermoZonesMenuView = zonesMenuView.extend({
    afterRender : function() {
      var that        = this;

      if (this.model.collection.at(0))
      {
        if(this.model.collection.at(0).get("probesModel"))
          if (this.model.collection.at(0).get("probesModel").get("useMainControlUnitAsMasterProbe")) {
              $(this.el).find(".zones").sortable({
                axis: 'y',
                update: function(event, ui) {
                  that.sortZones();
                  that.options.stepEventAggregator.trigger("order:changed");
                },
                items : "li:not(:first):not(.separator)"
              });
              $(this.el).find("li:first").addClass("locked");
            }
          else
          {
            $(this.el).find(".zones").sortable({
              axis: 'y',
              update: function(event, ui) {
                that.sortZones();
                that.options.stepEventAggregator.trigger("order:changed");
              },
              items : "li:not(.outOfCollection):not(.separator)"
            });
            $(this.el).find("li:first").removeClass("locked");
          }
      }

      $(this.el).find(".zones").disableSelection();

      var menuView        = this.$el;
      var menuTitleView   = menuView.find(".titleBar");
      var menuZoneListView= menuView.find("#zoneList");

      // menuZoneListView.height(menuView.height()-menuTitleView.height());
    }
  });

  // Required, return the module for AMD compliance
  return thermoZonesMenuView;

});